// Página de contato e agendamento.
// Só dados reais: NAP (src/lib/itv/site.ts), agendamento (Tintim) e rotas existentes.
import { Link } from "@tanstack/react-router";

import {
  bauruLink,
  consultaOnlineLink,
  homeLink,
} from "@/components/site-nav";
import { MAPS_BUSCA, MAPS_EMBED, NAP, REDES } from "@/lib/itv/site";
import { useAgendamentoLink } from "@/lib/itv/agendamento";

export function Contato() {
  const agendar = useAgendamentoLink();
  return (
    <div className="pag-contato">
      <section className="hero">
        <div className="container hero-inner">
          <nav className="trilha" aria-label="Você está em">
            <Link {...homeLink}>Home</Link> <span aria-hidden="true">›</span>{" "}
            <span>Contato</span>
          </nav>
          <p className="hero-sobretitulo">CONTATO E AGENDAMENTO</p>
          <h1>
            Fale com o <em>consultório</em>.
          </h1>
          <p className="hero-chamada">
            Endereço, telefone, e-mail e agendamento da consulta presencial em Bauru ou da
            teleconsulta para todo o Brasil.
          </p>
        </div>
      </section>

      <section className="endereco-mapa">
        <div className="container endereco-grade">
          <div className="card-endereco">
            <h2 className="rotulo">ENDEREÇO</h2>
            <a className="endereco-link" href={MAPS_BUSCA}>
              <address className="endereco">
                {NAP.logradouro.split(", Sala")[0]}
                <br />
                Sala 7, Torre 2 · {NAP.bairro}
                <br />
                {NAP.cidade}–{NAP.uf} · {NAP.cep}
              </address>
            </a>
            <p className="contato">
              <a href={`tel:${NAP.telefoneE164}`}>{NAP.telefone}</a>
              <br />
              <a href={`mailto:${NAP.email}`}>{NAP.email}</a>
            </p>
            <p className="como-chegar">
              <a href={MAPS_BUSCA}>COMO CHEGAR →</a>
            </p>
            <a className="btn-ouro btn-endereco" href={agendar}>
              Agendar pelo WhatsApp
            </a>
          </div>

          <div className="mapa">
            <iframe
              src={MAPS_EMBED}
              title={`Mapa do consultório em ${NAP.cidade}`}
              width="600"
              height="450"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      <section className="canais">
        <div className="container">
          <p className="sobretitulo">COMO AGENDAR</p>
          <h2>Consulta presencial ou por vídeo</h2>
          <ul className="grade">
            <li className="card">
              <h3>Em Bauru</h3>
              <p>
                Consulta presencial no consultório, com hora marcada, bioimpedância feita na
                própria consulta e acompanhamento do início ao fim.
              </p>
              <Link className="btn-contorno" {...bauruLink}>
                Consultório em Bauru →
              </Link>
            </li>
            <li className="card">
              <h3>Todo o Brasil</h3>
              <p>
                Teleconsulta por vídeo, com análise de histórico, sintomas, hábitos e exames,
                acompanhada a distância com hora marcada.
              </p>
              <Link className="btn-contorno" {...consultaOnlineLink}>
                Teleconsulta →
              </Link>
            </li>
          </ul>
          <a className="btn-ouro canais-btn" href={agendar}>
            Agendar pelo WhatsApp
          </a>
        </div>
      </section>

      <section className="redes">
        <div className="container redes-inner">
          <p className="sobretitulo">ACOMPANHE</p>
          <p className="redes-links">
            <a href={REDES.instagram}>Instagram</a>
            <span aria-hidden="true">·</span>
            <a href={REDES.youtube}>YouTube</a>
          </p>
        </div>
      </section>
    </div>
  );
}
